export const Permissions = {
    // Platform-level permissions (system_admin only)
    MANAGE_PLATFORM: 'manage:platform',
    VIEW_ALL_TENANTS: 'view:all_tenants',
    MANAGE_SUBSCRIPTIONS: 'manage:subscriptions',
    // Tenant-level permissions
    MANAGE_TENANT: 'manage:tenant', // Owner-only: tenant settings, plan changes
    MANAGE_USERS: 'manage:users', // Owner + Admin: invite, disable, role changes
    MANAGE_CLIENTS: 'manage:clients',
    VIEW_CLIENTS: 'view:clients',
    MANAGE_BILLING: 'manage:billing', // Owner-only: Stripe connect, payment config
    VIEW_BILLING: 'view:billing',
    MANAGE_DOCUMENTS: 'manage:documents',
    VIEW_DOCUMENTS: 'view:documents',
    MANAGE_BOT: 'manage:bot',
    SEND_MESSAGES: 'send:messages',
    VIEW_MESSAGES: 'view:messages',
    MANAGE_MATTERS: 'manage:matters',
    VIEW_MATTERS: 'view:matters',
    MANAGE_CONTACTS: 'manage:contacts',
    VIEW_CONTACTS: 'view:contacts',
    MANAGE_ORGANIZATIONS: 'manage:organizations',
    VIEW_ORGANIZATIONS: 'view:organizations',
    MANAGE_SETTINGS: 'manage:settings', // Owner + Admin: compliance, settings
};
export const RolePermissions = {
    system_admin: Object.values(Permissions),
    owner: [
        // Owner has ALL tenant-level permissions including billing and tenant management
        Permissions.MANAGE_TENANT,
        Permissions.MANAGE_USERS,
        Permissions.MANAGE_CLIENTS,
        Permissions.VIEW_CLIENTS,
        Permissions.MANAGE_BILLING,
        Permissions.VIEW_BILLING,
        Permissions.MANAGE_DOCUMENTS,
        Permissions.VIEW_DOCUMENTS,
        Permissions.MANAGE_BOT,
        Permissions.SEND_MESSAGES,
        Permissions.VIEW_MESSAGES,
        Permissions.MANAGE_MATTERS,
        Permissions.VIEW_MATTERS,
        Permissions.MANAGE_CONTACTS,
        Permissions.VIEW_CONTACTS,
        Permissions.MANAGE_ORGANIZATIONS,
        Permissions.VIEW_ORGANIZATIONS,
        Permissions.MANAGE_SETTINGS,
    ],
    admin: [
        // Admin can manage users, clients, docs, bot — but NOT billing or tenant settings
        Permissions.MANAGE_USERS,
        Permissions.MANAGE_CLIENTS,
        Permissions.VIEW_CLIENTS,
        Permissions.VIEW_BILLING,
        Permissions.MANAGE_DOCUMENTS,
        Permissions.VIEW_DOCUMENTS,
        Permissions.MANAGE_BOT,
        Permissions.SEND_MESSAGES,
        Permissions.VIEW_MESSAGES,
        Permissions.MANAGE_MATTERS,
        Permissions.VIEW_MATTERS,
        Permissions.MANAGE_CONTACTS,
        Permissions.VIEW_CONTACTS,
        Permissions.MANAGE_ORGANIZATIONS,
        Permissions.VIEW_ORGANIZATIONS,
        Permissions.MANAGE_SETTINGS,
    ],
    lawyer: [
        Permissions.MANAGE_CLIENTS,
        Permissions.VIEW_CLIENTS,
        Permissions.VIEW_BILLING,
        Permissions.MANAGE_DOCUMENTS,
        Permissions.VIEW_DOCUMENTS,
        Permissions.SEND_MESSAGES,
        Permissions.VIEW_MESSAGES,
        Permissions.MANAGE_MATTERS,
        Permissions.VIEW_MATTERS,
        Permissions.MANAGE_CONTACTS,
        Permissions.VIEW_CONTACTS,
        Permissions.MANAGE_ORGANIZATIONS,
        Permissions.VIEW_ORGANIZATIONS,
    ],
    paralegal: [
        Permissions.VIEW_CLIENTS,
        Permissions.VIEW_BILLING,
        Permissions.VIEW_DOCUMENTS,
        Permissions.VIEW_MESSAGES,
        Permissions.SEND_MESSAGES,
        Permissions.VIEW_MATTERS,
        Permissions.VIEW_CONTACTS,
        Permissions.VIEW_ORGANIZATIONS,
    ],
};
//# sourceMappingURL=permissions.js.map